import { useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { useBreadcrumb } from "../../contexts/BreadcrumbContext.jsx";
import IncomingMailsTable from "../../components/tables/IncomingMailsTable.jsx";
import MailDetailSplit from "../../components/mail/MailDetailSplit.jsx";

/**
 * Posteingang — the incoming-mail inbox. Matches the click dummy: a filter-tab
 * list (Alle / Nicht zugeordnet / Zugeordnet / Papierkorb) with a persistent
 * inline detail split-pane below it. The "Gesendet" (outgoing) view is
 * intentionally hidden to mirror the dummy's inbox-only Posteingang.
 *
 * URL: /admin/emails/:subFolder?/:mailId?  (mainFolder is always the inbox)
 */
export default function MailMatchingPage() {
  const { subFolder = "not_assigned", mailId } = useParams();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Posteingang", path: "/admin/emails" },
    ]);
  }, [setBreadcrumbs]);

  const handleRowClick = (mail) => {
    navigate(`/admin/emails/${subFolder}/${mail.id}`);
  };

  const handleFolderChange = useCallback(
    (folderKey) => {
      navigate(`/admin/emails/${folderKey}`, { replace: true });
    },
    [navigate]
  );

  return (
    <Box>
      <IncomingMailsTable
        folder={subFolder}
        onRowClick={handleRowClick}
        onFolderChange={handleFolderChange}
        selectedMailId={mailId ? Number(mailId) : null}
      />
      <MailDetailSplit mailId={mailId} />
    </Box>
  );
}
